import React, { memo } from "react";
import { Tag, Typography } from "antd";
import {
  CheckCircleOutlined,
  InfoCircleOutlined,
  SafetyCertificateOutlined,
  SlidersOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

const AlgorithmOverviewGuide = memo(function AlgorithmOverviewGuide({
  selectedFlightModel,
}) {
  return (
    <div className="box_wraper_div playground_overview_card">
      <div className="playground_card_header">
        <div className="playground_card_header_left">
          <Text className="playground_card_title">Live Overview & Guide</Text>
          <Text className="playground_card_subtitle">
            Algorithm scoring criteria, weight normalisation & ranking workflow
          </Text>
        </div>
        <Tag color="blue" className="playground_model_tag">
          {selectedFlightModel || "737-MAX"}
        </Tag>
      </div>

      {/* Simulation Principles & Guidelines (Three Static Cards) */}
      <div className="playground_overview_stats">
        <div className="playground_stat_box">
          <div className="playground_principle_top">
            <span className="playground_stat_label">SAFETY & ISOLATION</span>
            <SafetyCertificateOutlined
              style={{ color: "#2563eb", fontSize: "15px" }}
            />
          </div>
          <span className="playground_stat_val">Isolated Simulation</span>
          <span className="playground_stat_sub">
            Hypothetical weight adjustments simulate ranking without altering live production rankings.
          </span>
        </div>

        <div className="playground_stat_box">
          <div className="playground_principle_top">
            <span className="playground_stat_label">BALANCED PRIORITIES</span>
            <SlidersOutlined
              style={{ color: "#7c3aed", fontSize: "15px" }}
            />
          </div>
          <span className="playground_stat_val">Importance Levels</span>
          <span className="playground_stat_sub">
            Set how much each parameter matters on a simple 1–5 scale. The system balances the final result for you.
          </span>
        </div>

        <div className="playground_stat_box">
          <div className="playground_principle_top">
            <span className="playground_stat_label">GOVERNANCE & AUDIT</span>
            <CheckCircleOutlined
              style={{ color: "#059669", fontSize: "15px" }}
            />
          </div>
          <span className="playground_stat_val">Production Re-Rank</span>
          <span className="playground_stat_sub">
            Saving updates live algorithm weights and triggers ranking grid recalculation for all users.
          </span>
        </div>
      </div>

      {/* Simulation Workflow Steps */}
      <div className="playground_guide_section">
        <div className="playground_guide_heading">
          <InfoCircleOutlined style={{ color: "#2563eb", marginRight: 6 }} />
          <span>How Algorithm Simulation Works</span>
        </div>

        <div className="playground_guide_steps">
          <div className="playground_guide_step">
            <div className="playground_step_num">1</div>
            <div className="playground_step_text">
              <Text strong className="playground_step_title">
                Set Importance (1 - 5)
              </Text>
              <Text className="playground_step_desc">
                Click "Edit Importance Values" to adjust parameter importance from 1 (Lowest) to 5 (Highest) across defect, specification, regulatory, and cost criteria.
              </Text>
            </div>
          </div>

          <div className="playground_guide_step">
            <div className="playground_step_num">2</div>
            <div className="playground_step_text">
              <Text strong className="playground_step_title">
                Simulate Ranking Changes
              </Text>
              <Text className="playground_step_desc">
                Click "Simulate Ranking" to compute new normalised weights and preview specification rank movements with Rise/Fall indicators.
              </Text>
            </div>
          </div>

          <div className="playground_guide_step">
            <div className="playground_step_num">3</div>
            <div className="playground_step_text">
              <Text strong className="playground_step_title">
                Review & Apply Changes
              </Text>
              <Text className="playground_step_desc">
                Review the simulation results table below. Click "Apply Changes" to commit the new algorithm weights and update production rankings across the system.
              </Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default AlgorithmOverviewGuide;
